function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_406_6628)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.432 3.307a1 1 0 01-.029 1.414l-25 24a1 1 0 01-1.385-1.442l25-24a1 1 0 011.414.028zM25.526 11.25a1 1 0 011.397-.218 28.425 28.425 0 014.248 3.81l.004.005a3.218 3.218 0 010 4.306l-.003.004C27.68 23 21.885 27.093 15.995 27a14.313 14.313 0 01-4.34-.644 1 1 0 11.594-1.91c1.212.377 2.474.563 3.744.554h.024c5.038.085 10.325-3.503 13.673-7.186a1.217 1.217 0 000-1.627 26.416 26.416 0 00-3.946-3.54 1 1 0 01-.218-1.397zM16.003 7a13.732 13.732 0 013.456.406 1 1 0 01-.483 1.94A11.732 11.732 0 0015.983 9c-4.95-.082-10.252 3.426-13.67 7.184a1.217 1.217 0 000 1.626 26.727 26.727 0 003.339 3.082 1 1 0 01-1.227 1.58 28.736 28.736 0 01-3.591-3.316l-.005-.005a3.217 3.217 0 010-4.307l.003-.003C4.402 10.914 10.21 6.91 16.002 7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 13a3.999 3.999 0 00-4 4 1 1 0 01-2 0 5.998 5.998 0 016-6 1 1 0 010 2zM21 15.999a1 1 0 011 1A5.999 5.999 0 0116 23a1 1 0 110-2 4 4 0 004-4.001 1 1 0 011-1z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_406_6628"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));